export default {
  'shipment.track-trace.title': 'Track & Trace',
  'shipment.show_routes': 'Show Routes',
  'shipment.batch_request_number': 'Batch Request No.',
};
